import { AppLayout } from 'layouts';
import { Col, Row, Title } from 'ui';
import { NotificationsList, NotificationsNav } from 'features/notifications';

const PageNotifications = () => (
  <AppLayout>
    <Row>
      <Col flex="1">
        <Title level={1} marginBottom>
          Notifications
        </Title>
      </Col>
      <Col>
        <NotificationsNav />
      </Col>
      <Col span={24}>
        <NotificationsList />
      </Col>
    </Row>
  </AppLayout>
);

export default PageNotifications;
